import type { SimulatorSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { hover } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

const AreaStyled = styled.div<{
  $styles: ElementStyleCss<SimulatorSchemaType>
  $selected: boolean
  $isDragging: boolean
  $highlight: boolean
  $hidden?: boolean
  $disabled?: boolean
  $linked?: boolean
  $isPreview?: boolean
}>`
  width: 100%;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  background-color: #e6e6e633;
  background-color: ${({ $styles, $isPreview, $linked, $hidden }) =>
    $hidden
      ? 'transparent'
      : $linked || ($isPreview && !$linked)
        ? $styles.area?.backgroundColor
        : '#e6e6e633'};
  border-color: ${({ $styles, $isPreview, $linked, $hidden }) =>
    $hidden
      ? 'transparent'
      : $linked || ($isPreview && !$linked)
        ? $styles.area?.borderColor
        : 'var(--color-text-secondary)'};

  cursor: ${({ $selected, $isDragging, $disabled, $linked }) => {
    if ($disabled) {
      return 'auto'
    }
    if ($isDragging) {
      return 'grabbing'
    }
    if ($selected) {
      return 'grab'
    }
    return $linked ? 'pointer' : 'auto'
  }};

  ${hover}
`

export default AreaStyled
